import type { FC } from 'react';
import * as Styled from './styled';
import type { SearchOptionProps } from './types';

export * from './types';

export const SearchOption: FC<SearchOptionProps> = (props) => {
  const { image, title, subtitle, children, ...rest } = props;

  return (
    <Styled.Wrapper {...rest}>
      <Styled.Img src={image} />
      <Styled.TextWrapper>
        <Styled.Title>{title}</Styled.Title>
        <Styled.Text>{subtitle}</Styled.Text>
        {children}
      </Styled.TextWrapper>
    </Styled.Wrapper>
  );
};
